export default __webpack_public_path__ + "static/media/0168.10836380.png";